// @flow
import { createSelector } from 'reselect'

const cards = (state) => state.cards.cards

export const getCards = createSelector(
  [cards],
  (cards) => cards
)

const currentCard = (state) => state.cards.currentCard

export const getCurrentCard = createSelector(
  [currentCard],
  (currentCard) => currentCard
)

const newCard = (state) => state.cards.newCard

export const getNewCard = createSelector(
  [newCard],
  (newCard) => newCard
)

const updateCard = (state) => state.cards.updateCard

export const getUpdateCard = createSelector(
  [updateCard],
  (updateCard) => updateCard
)

const deleteCard = (state) => state.cards.deleteCard

export const getDeleteCard = createSelector(
  [deleteCard],
  (deleteCard) => deleteCard
)
